import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "shrink-0 min-w-0" }
const _hoisted_2 = { class: "flex-1 min-h-0 min-w-0 overflow-y-auto overflow-x-hidden overscroll-y-contain" }
const _hoisted_3 = {
  key: 0,
  class: "shrink-0 min-w-0"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminModalShell',
  props: {
    maxWidthClass: { default: "max-w-md" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bg-white rounded-2xl shadow-2xl w-full flex flex-col overflow-hidden transform transition-all max-h-[min(92vh,880px)]", __props.maxWidthClass])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "header")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    (_ctx.$slots.footer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "footer")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})